package api.interfaces

interface ICSMarksAllowedFieldParser {
    val fields: Array<String>

    fun parseOriginalICSFieldNames(): Array<String> {
        return mutableListOf<String>().apply {
            fields.forEach {
                this.add(
                    when(it) {
                        "RecordId" -> "recordId"
                        "Eigenaar" -> "owner"
                        "Klant" -> "customer"
                        "Klant_omschrijving" -> "customerDescription"
                        "Klantreferentie" -> "customerReference"
                        "Naam" -> "name"
                        "Adres" -> "address"
                        "Postcode" -> "zipCode"
                        "Plaats" -> "city"
                        "Land" -> "country"
                        "Emailadres" -> "email"
                        "Artikelgroep" -> "articleCategory"
                        "Aantal_Containers" -> "containerAmount"
                        "Aantal_ontvangen" -> "amountReceived"
                        "Te_ontvangen_aantal" -> "amountToReceive"
                        "Eind_datumtijd" -> "endDateTime"
                        "Invoerdatumtijd" -> "inputDateTime"
                        "Referentie_extern" -> "externalReference"
                        "Referentie_intern" -> "internalReference"
                        "Special" -> "special"
                        "Statusomschrijving" -> "statusDescription"
                        "Toelichting" -> "explanation"
                        "Webshop" -> "webShop"
                        "Opdrachttype" -> "assignmentType"
                        "Referentie" -> "reference"
                        "Orderdatum" -> "orderDate"
                        "Te_picken_aantal" -> "amountToPick"
                        "Aantal_verzendeenheden" -> "deliveryUnitsAmount"
                        "Bericht" -> "message"
                        "Controle_Conform" -> "manuallyChecked"
                        "Doostype" -> "boxType"
                        "Expediteur" -> "shippingAgent"
                        "Gepickt_aantal" -> "pickedAmount"
                        "Gevraagde_datumtijd" -> "requestedDateTime"
                        "Inpakker" -> "packer"
                        "Inpakstation" -> "packingStation"
                        "OnHold" -> "onHold"
                        "Outbound_DVE" -> "outboundTransportUnit"
                        "Outboundtijd" -> "outboundTime"
                        "PARCELSHOPID" -> "parcelShopId"
                        "Pakbon_Mailadres_extra" -> "packingSlipEmailExtra"
                        "Pakbon_Mailen" -> "mailPackingSlip"
                        "Prioriteit" -> "priority"
                        "Regiocode" -> "regionalCode"
                        "Service" -> "service"
                        "Speciale_Pakbon" -> "specialPackingSlip"
                        "Telefoonnummer" -> "phone"
                        "Tijdelijke_locatie" -> "temporaryLocation"
                        "Track_Trace" -> "trackAndTrace"
                        "Uitlevercode" -> "deliveryCode"
                        "VerdeelzoneStatusOmschrijving" -> "packingStatus"
                        "Verwerkingsbatch" -> "batch"
                        "Verzendeenheden" -> "deliveryUnits"
                        "Verzendoptie" -> "deliveryOption"
                        "Verzendvoorstel" -> "deliveryProposal"
                        "Opdrachtnummer" -> "orderNumber"
                        "Weeknummer" -> "weekNumber"
                        "Behandeling" -> "treatment"
                        "Ontvangen_Detail" -> "receivedDetailed"
                        "Ontvanger" -> "receiver"
                        "Tijdstatus" -> "timeStatus"
                        "Totaal_verwacht" -> "totalExpected"
                        "Totaal_ontvangen" -> "totalReceived"
                        "Verwacht_Detail" -> "expectedDetail"
                        "Verwachte_datum" -> "expectedDate"
                        "Verwerkingsdatum" -> "processingDate"
                        else -> it
                    }
                )
            }
        }.filter { it != "" }.toTypedArray()
    }
}